import { render, staticRenderFns } from "./GuiaImpresso.vue?vue&type=template&id=7a5098ec&scoped=true"
import script from "./GuiaImpresso.vue?vue&type=script&lang=js"
export * from "./GuiaImpresso.vue?vue&type=script&lang=js"
import style0 from "./GuiaImpresso.vue?vue&type=style&index=0&id=7a5098ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5098ec",
  null
  
)

export default component.exports